:root {
  --color-light-bg: #FFFFDD; /* jaune clair */
  --color-dark-bg: #000032; /* Bleu foncé */
  --color-light-text: #FFFFBB;
  --color-dark-text: #000080;

  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#logo {
  max-width: 90%;
}

@font-face {
  font-family: "simple-line-icons";
  src: url("/fonts/simple-line-icons.woff2") format("woff2"),
       url("/fonts/simple-line-icons.woff") format("woff"),
       url("/fonts/simple-line-icons.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}


/* LINE ICONS */
@font-face {
  font-family: "line-icons";
  src: url("/fonts/lineIcons.woff2") format("woff2"),
       url("/fonts/LineIcons.woff") format("woff"),
       url("/fonts/LineIcons.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

/* ET-LINE */
@font-face {
  font-family: "et-line";
  src: url("/fonts/et-line.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

/* FONT AWESOME — ⚠️ le nom dépend de la version que tu as ! */
@font-face {
  font-family: "FontAwesome"; /* v4: 'FontAwesome' */
  src: url("/fonts/fontawesome-webfont.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}


nav .icon.mail::after {
  font-family: "simple-line-icons";
  content: "\e01e";
}

nav .icon.phone::after {
  font-family: "simple-line-icons";
  content: "\e600"; /* ajuste au bon codepoint */
}
